import type { LocaleCode } from '@ifixit/i18n';
import type { PropsWithChildren } from 'react';
import { SmartLink } from 'Shared/smart_link';

export type SupportLinkProps = PropsWithChildren<{
   localeCode: LocaleCode;
}>;
export function SupportLink({ children, localeCode }: SupportLinkProps) {
   return (
      <SmartLink href="/Support" localeCode={localeCode}>
         {children}
      </SmartLink>
   );
}
